<!--- Generic header, inclusing current brand and a button to select another brand -->

<div class="grid">
    <div class="col-8">
        <app-brand-admin-header></app-brand-admin-header>
    </div>  
    <div class="col-2">
        <button pButton type="button" label="Back to Field Set" icon="pi pi-backward" iconPos="left" (click)="brandOfferRedirect($event)"  
            class="p-button-raised p-button-rounded" [disabled]="isDetailsShown">
        </button>
    </div>

    <!-- <div class="col-2">
        <button pButton type="button" label="Back to Field Set" icon="pi pi-backward" iconPos="left" (click)="brandOfferRedirect($event)"  
             class="p-button-raised p-button-rounded" [disabled]="isDetailsShown">
         </button>
    </div>   -->
 </div> 

<!--   -->

<div class="grid">

    <!--- First card with the master list -->

    @if (isListShown && showItem()) {
        <!-- <div @flyInOut class="col-10 side-list-content-data"> -->
        <div class="col-10 panel" animate.enter="fly-in" animate.leave="fly-out">
            <!-- The list of Field Sets -->

            @if (isListOfOfferFieldsShown) {
            <div class="row">

                <div class="col-12">

                    <p-card header="List of Fields" subheader="" class="ui-card-powder" >
        
                        <p-table #dt [columns]="cols" [value]="offerFields" selectionMode="single" class="wal-table"
                                style="width:100%"
                                sortMode="multiple"  [paginator]="true" [rows]="50" [rowsPerPageOptions]="[15,25,50,75]">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th [ngStyle]="{'width': 'table-cell', 'display': '2%'}">
                                    </th>
                                    @for (col of columns; track col.field) {
                                        <th [pSortableColumn]="col.field"
                                            [style.display]="col.display"
                                            [style.width]="col.width">
                                            {{ col.header }}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    }
                                    <th [ngStyle]="{'width': 'table-cell', 'display': '8%'}">
                                    </th>
                                </tr>

                                <tr>
                                    <td style="background-color: white"></td>

                                    @for (col of columns; track col.field) {
                                        <th [style.width]="col.width" [style.display]="col.display">
                                            @switch (col.field) {
                                                @case ('fieldType') {
                                                    <p-multiSelect
                                                        [options]="offerFieldTypes"
                                                        [(ngModel)]="selectedFieldTypes"
                                                        (onChange)="onFieldTypeFilterChange()"
                                                        optionLabel="label"
                                                        optionValue="label"
                                                        placeholder="Filter Field Type"
                                                        [style]="{'width': '150px'}">
                                                    </p-multiSelect>
                                                }
                                                @case ('fieldKey') {
                                                    <input pInputText type="text" (input)="dt.filter($any($event.target).value, 
                                                        col.field, 'contains')"  [style]="{'width':'90%'}"
                                                    >
                                                }
                                                @default {
                                                }
                                            }
                                        </th>
                                    }                                 

                                    <td style="background-color: white"></td>
                                </tr>

                            </ng-template>


                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
                                <tr  [pReorderableRow]="index">
                                    <td>
                                        <i class="pi pi-bars" pReorderableRowHandle></i>
                                    </td>                                
                                    @for (col of columns; track col.field) {
                                        <td [style.width]="col.width" [style.display]="col.display">
                                            {{ rowData[col.field] }}
                                        </td>
                                    }
                                    <td style="text-align:center">
                                        <button pButton type="button" icon="pi pi-pencil" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}" 
                                            data-toggle="tooltip" data-placement="top" title="Modify field set" 
                                            class="ui-button-info" (click)="onRowEdit(rowData)">
                                        </button> 
                                        <button pButton type="button" icon="pi pi-times" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                                            data-toggle="tooltip" data-placement="top" title="Delete field set" 
                                            class="ui-button-danger" (click)="onRowDelete(rowData)" *ngIf="isSubmitShown">
                                        </button>                                
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="summary" let-rowData >
                                @if(isSubmitShown) {
                                <div class="mt-2 text-left">
                                    <p-button type="submit" label="Add" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="showDialogToAdd()"></p-button>
                                    <p-button type="button" label="Save Field Order" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="saveFieldOrder()"></p-button>
                                </div>
                                }
                            </ng-template>    

                        </p-table> 

                        <p-footer>
                            <mat-icon class="nav-caption wal-center">list_all</mat-icon>
                        </p-footer>
                    </p-card>
                        
                </div>
        
            </div>

            }
    
        </div>

    }

    <!--- Second card with the details -->

    @if(isDetailsShown && showItem()) {
        <!-- <div @flyInOut class="col-10 side-list-content-data"> -->
        <div class="col-10 panel" animate.enter="fly-in" animate.leave="fly-out">

            <div class="col-8">

                <p-card header="Field Details" subheader="" class="ui-card-light" >
                
                    <form (ngSubmit)="onSubmit()" [formGroup]="form">

                        <div *ngFor="let offerFieldAttribute of offerField.offerFieldAttributes" class="form-row">
                            <app-attribute [offerFieldAttribute]="offerFieldAttribute" [form]="form" 
                                *ngIf="!(offerFieldAttribute?.key=='offerFieldId' && isNewOfferField)"
                                (changeFieldTypeEvent)="changeFieldType($event)"
                                (changeOfferLinkEvent)="changeOfferLink($event)"
                                (captureColorEvent)="captureColor($event)"
                                (showImageEvent)="showImage($event)"
                                (hideImageEvent)="hideImage($event)" >
                            </app-attribute>
                        </div>

                        <div class="form-row" style="text-align:left">
                            <p-button type="submit" label="Submit" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" [disabled]="!form.valid" *ngIf="isSubmitShown" ></p-button>
                            <p-button type="button" label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancelDetails()"></p-button>
                            <p-button type="button" label="Functions Cheat Sheet" styleClass="p-button-info wal-info p-button-raised p-button-rounded float-right" (click)="onFunctionsCheatSheet()"></p-button>
                        </div>                    

                    </form>
            
                    <p-footer>
                        <mat-icon class="nav-caption wal-center">view_compact</mat-icon>
                    </p-footer>
                </p-card>

            </div>

            @if(isImagePreviewShown) {
            <div class="col-2" styleClass="ui-card-light">
                <img [src]="image" />
            </div>
            }

        </div>
    }

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="offer-fields"></p-confirmDialog>

